'use client';

import { useCallback } from 'react';
import useVelocityClient from 'src/hooks/useVelocityClient';
import {
	VelocityClientTxSignedHandler,
	TxMetricsOpts,
} from 'src/stores/VelocityStore/types';
import { sendTxAndRecordConfirmationTime } from 'src/stores/VelocityStore/helpers/transactionHelpers';

/**
 * Hook for handling transaction chains with proper metrics and confirmation tracking
 */
export const useHandleTxChain = () => {
	const velocityClient = useVelocityClient();

	const handleTxChain = useCallback(
		async <T extends Promise<unknown>>(
			txPromise: T,
			onSigned?: VelocityClientTxSignedHandler,
			opts?: TxMetricsOpts
		) => {
			if (!velocityClient) return;
			return sendTxAndRecordConfirmationTime(
				velocityClient,
				txPromise,
				onSigned,
				opts
			);
		},
		[velocityClient]
	);

	return { handleTxChain };
};
